/* Shared with the code-search form on the Search screen and the search box on
   the parts listing. The two have to agree: a client searches from the form,
   lands on the listing, and searches again from the box - a shorter minimum on
   either side would accept a term the other had just rejected. */
export const PART_CODE_MIN_LENGTH = 5;
